// @flow
import type { Action } from 'app/common/redux/types';
import type { BoardSortOptionsType } from 'app/packages/pinterest-flow-types/user';

export type State = {
  profileBoardView: ?('square' | 'list' | 'wide'),
  updatedBoardOrder?: BoardSortOptionsType,
  boardPinView: '' | 'regular' | 'dense',
  profilePinView: '' | 'regular' | 'dense',
};

const initialState = {
  profileBoardView: null,
  updatedBoardOrder: undefined,
  boardPinView: '',
  profilePinView: '',
};

const profileViewReducer = (state: State = initialState, action: Action): State => {
  if (action.type === 'UPDATE_BOARD_SORT_OPTION') {
    const {
      payload: { updatedBoardOrder },
    } = action;
    return {
      ...state,
      updatedBoardOrder,
    };
  } else if (action.type === 'UPDATE_PROFILE_BOARD_VIEW') {
    const {
      payload: { profileBoardView },
    } = action;
    return {
      ...state,
      profileBoardView,
    };
  } else if (action.type === 'UPDATE_BOARD_PIN_VIEW') {
    const {
      payload: { boardPinView },
    } = action;
    return {
      ...state,
      boardPinView,
    };
  } else if (action.type === 'UPDATE_PROFILE_PIN_VIEW') {
    const {
      payload: { profilePinView },
    } = action;
    return {
      ...state,
      profilePinView,
    };
  }

  return state;
};

export default profileViewReducer;
